const originalClipboard =
  typeof navigator === 'undefined' ? {} : navigator.clipboard;

const install = () => {
  if (typeof navigator === 'undefined') {
    return;
  }

  navigator.clipboard = {
    writeText: () => Promise.resolve(),
  };
};

const uninstall = () => {
  navigator.clipboard = originalClipboard;
};

export default {
  install,
  uninstall,
};
